import { mapActions } from 'vuex';
import { ROW } from './QuotationModel';

export default {
  computed: {
    projectWidth: {
      get() {
        if (this.quotation.service && this.quotation.service.project_width) {
          return this.quotation.service.project_width;
        }
        return 0;
      },
      set(val) {
        return val;
      },
    },
    projectLength: {
      get() {
        if (this.quotation.service && this.quotation.service.project_length) {
          return this.quotation.service.project_length;
        }
        return 0;
      },
      set(val) {
        return val;
      },
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    calculationQuotaion(group, index) {
      if (this.template == null) {
        this.activeAlert({ message: 'Template inválido', theme: 'danger' });
        return false;
      }
      if (group.project_dimensions.type == null) {
        this.activeAlert({
          message: 'Tipo de grama inválido',
          theme: 'danger',
        });
        return false;
      }
      this.$nextTick(() => {
        group.project_dimensions.template_id = this.template.id;
        group.obligations_buyer = this.template.obligations_buyer;
        group.obligations_seller = this.template.obligations_seller;
        this.fillGroupRows(group, index);
        group.name = `${this.projectWidth}x${this.projectLength} - ${group.rows[0].description} - GARANTIA DA GRAMA ${group.rows[0].variation.warranty}`;
      });
      return group;
    },
    fillGroupRows(group, index) {
      group.rows = [];
      this.template.rows.map((row, nav) => {
        group.rows.push({
          ...ROW,
          value: row.variation && row.variation.price ? Number(row.variation.price) : 1,
          quantity: this.getQuantityByType(row, group),
          unit_type: row.variation && row.variation.product && row.variation.product.unit_type
            ? row.variation.product.unit_type.name
            : 'un',
          description: row.variation ? row.variation.name : '',
          variation_id: row.variation_id,
          variation: row.variation,
        });
        this.setTotal(group.rows[nav], index);
        return row;
      });
      this.$nextTick(() => {
        this.setProductInAutocomplete();
      });
      return group;
    },
    getQuantityByType(row, group) {
      const area = this.projectWidth * this.projectLength;
      switch (row.type.slug) {
        case 'alambrado': return this.getFenceQtd(group);
        case 'iluminacao': return this.getIluminationGroupQtd(area);
        case 'borracha': return this.getRubberQtd(area, group);
        case 'tape': return this.getTapeQtd(area);
        case 'cola': return this.getGlueQtd(area);
        case 'silica': return this.getSilicaQtd(area, group);
        case 'area-fina': return this.getSandQtd(area, group);
        case 'grama-branca': return this.getWhiteGrassQtd();
        case 'contrapiso':
        case 'grama':
          return area;
        default:
          return 1;
      }
    },
    getIluminationGroupQtd(area) {
      const { illumination } = this.$store.state.settings.settings.quotation;
      area = parseInt(area, 10);
      const selected = illumination.filter(row => (
        area <= parseInt(row.max, 10) && area >= parseInt(row.min, 10)
      ));
      if (selected.length) {
        if (selected[0].conjuntos) {
          return selected[0].conjuntos;
        }
      }
      return 1;
    },
    getRubberQtd(area, group) {
      const grass = this.template.rows.filter(row => (
        row.type && row.type.slug === 'grama'
      ))[0];
      const { type } = group.project_dimensions;
      const { rubber } = this.$store.state.settings.settings.quotation;
      if (grass.variation.warranty) {
        const productWarranty = Number(grass.variation.warranty.replace(/[^0-9]/g, ''));
        const warranty = rubber.filter(row => (
          Number(row.warranty.replace(/[^0-9]/g, '')) === productWarranty && row.type === type
        ))[0];

        if (warranty) {
          return warranty.kilo * area;
        }
      }
      return area;
    },
    getTapeQtd(area) {
      return area / 2;
    },
    getSilicaQtd(area, group) {
      if (group.project_dimensions.type === 'fibrilada') {
        return area * 15;
      }
      return area * 20;
    },
    getSandQtd(area, group) {
      if (group.project_dimensions.type === 'fibrilada') {
        return area * 20;
      }
      return area * 25;
    },
    getWhiteGrassQtd() {
      return ((5 * this.projectWidth) + (2 * this.projectLength) + 10) * 0.12;
    },
    getGlueQtd(area) {
      return Math.ceil(area / 2 / 26);
    },
    getFenceQtd(group) {
      const { height } = group.project_dimensions;
      return ((this.projectWidth * 2) + (this.projectLength * 2)) * height;
    },
  },
};
